export const PersonsSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    aria-hidden="true"
    role="presentation"
    width={24}
    height={24}
  >
    <path
      d="M16.3,7.53a1.74,1.74,0,0,0-1.74-1.75,1.72,1.72,0,0,0-.68.14.66.66,0,0,1-.52-1.22,3.07,3.07,0,1,1-1.1,4.85.66.66,0,0,1,1-.87,1.77,1.77,0,0,0,1.31.59A1.74,1.74,0,0,0,16.3,7.53ZM20,15.25a.65.65,0,0,1-.21.48,1.06,1.06,0,0,1-.72.18H16.65c-.34,0-.72-.05-.85-.42a.66.66,0,0,1,.34-.84,1.21,1.21,0,0,1,.5-.07h1.72s-.2-.26-.23-.3-.18-.23-.28-.34a7.08,7.08,0,0,0-.59-.63,4.37,4.37,0,0,0-.69-.53c-.24-.16-.53-.25-.76-.42a.69.69,0,0,1-.32-.5.68.68,0,0,1,.6-.63,1.62,1.62,0,0,1,.91.22,6.29,6.29,0,0,1,2.23,1.9A3.81,3.81,0,0,1,20,14.87,1.63,1.63,0,0,1,20,15.25ZM2.47,16.71a7.22,7.22,0,0,1,3.36-3.66l1.5.91a.88.88,0,0,0,.91,0l1.5-.91c1.3.65,3.44,2.8,3.36,3.66ZM9.9,11.25a.91.91,0,0,0-.72.09l-1.39.84-1.4-.84a.87.87,0,0,0-.72-.09c-1.33.42-5.67,4-5.67,6.34a.87.87,0,0,0,.88.88H14.69a.87.87,0,0,0,.88-.88C15.57,15.23,11.23,11.67,9.9,11.25Zm-2.11-8A2.89,2.89,0,1,1,4.9,6.17,2.9,2.9,0,0,1,7.79,3.28Zm0,7.54A4.65,4.65,0,1,0,3.14,6.17,4.66,4.66,0,0,0,7.79,10.82Z"
      fillRule="evenodd"
      fill="currentColor"
    />
  </svg>
)
export default PersonsSvg
